import React from "react";
import Component from "./component"
import Wrapper from "../wrapper-component"

const WrapperComponent = (props) => {
  return <Wrapper><Component {...props}/></Wrapper>;
}
export default WrapperComponent
